var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-blog-image",style:({ backgroundImage: _vm.backgroundImage, paddingTop: _vm.paddingTop })})
}
var staticRenderFns = []

export { render, staticRenderFns }